import Vue from 'vue';

export const generateSolidGatePaymentIntentRequest = async ({
  session,
  order,
  personnelId,
  tips,
  payForSelectedItems,
}) => {
  return Vue.axios.post(`/payments/solidgate/payment-intent`, {
    session,
    order,
    personnel_id: personnelId,
    tips,
    pay_for_selected_items: payForSelectedItems,
  });
};

export const fetchStripePaymentIntentRequest = async ({
  session,
  order,
  personnelId,
  tips,
  payForSelectedItems,
}) => {
  return Vue.axios.post(`/payments/stripe/payment-intent`, {
    session,
    order,
    personnel_id: personnelId,
    tips: tips * 100,
    pay_for_selected_items: payForSelectedItems,
  });
};

export const generateCompositeSolidGatePaymentIntentRequest = async ({
  foodCourtSession,
  orders,
}) => {
  return Vue.axios.post('/payments/solidgate/payment-intent-composite', {
    food_court_session: foodCourtSession,
    orders,
  });
};

export const generateNeonPayTransactionRequest = async ({
  foodCourtSession,
  orders,
}) => {
  return Vue.axios.post(`/payments/neopay/create-transaction-composite`, {
    food_court_session: foodCourtSession,
    orders,
  });
};

export const createMollieIdealPaymentRequest = async ({
  session,
  order,
  personnelId,
  tips,
  payForSelectedItems,
}) => {
  return Vue.axios.post(`/payments/mollie/create-ideal-payment`, {
    session,
    order,
    personnel_id: personnelId,
    pay_for_selected_items: payForSelectedItems,
    tips,
  });
};

export const generateCashPaymentIntentRequest = async ({
  session,
  order,
  personnelId,
  tips,
  payForSelectedItems,
}) => {
  return Vue.axios.post(`/payments/cash/create-payment-intent`, {
    session,
    order,
    personnel_id: personnelId,
    tips: tips * 100,
    pay_for_selected_items: payForSelectedItems,
  });
};

export const createCashPaymentCallbackRequest = async ({ uuid, type }) => {
  return Vue.axios.post(`/payments/cash/callback`, {
    uuid,
    type,
  });
};

export const generateRoomBillPaymentIntentRequest = async ({
  session,
  order,
  personnelId,
  tips,
  payForSelectedItems,
}) => {
  return Vue.axios.post(`/payments/room-bill/create-payment-intent`, {
    session,
    order,
    personnel_id: personnelId,
    tips: tips * 100,
    pay_for_selected_items: payForSelectedItems,
  });
};

export const createRoomBillPaymentCallbackRequest = async ({ uuid, type }) => {
  return Vue.axios.post(`/payments/room-bill/callback`, {
    uuid,
    type,
  });
};
